import { FC } from 'react';
import { NeauviaPlayerLayer } from 'src/components/player';
import styled from 'styled-components';
import { ar } from 'src/styles/common';
import { Videos } from 'src/graphql/schema.graphql';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { Theme } from 'vendor/mods/styled-components';
import { redTheme } from 'src/styles/theme';

const Section = styled.section`
  background: ${({ theme }) => theme.palette.accent};
`;

const Container = styled(ConstraintContainer)`
  position: relative;
  ${ar(16 / 9, 'max(20vw, calc(100vh - var(--header-static-height) - 130px))')}
`;

interface AboutUsBannerVideoProps {
  video?: Videos;
}

export const AboutUsBannerVideo: FC<AboutUsBannerVideoProps> = ({ video }) => {
  return (
    <Theme theme={redTheme}>
      {video && (
        <Section>
          <Container>
            <NeauviaPlayerLayer autoPlay={false} video={video} />
          </Container>
        </Section>
      )}
    </Theme>
  );
};
